import connect from "../../../shared/data-store/connect";
import {
	ACTION_RESET_PRICE_FILTER,
	ACTION_SET_PRICE_FILTER,
	store,
} from "./DataStore";
import { track } from "../../tracker/EventTracker";
import PriceFilter from "../PriceFilter";

customElements.define(
	"esc-favorites-price-filter",
	class extends connect(PriceFilter, store) {
		update(state, views) {
			this.updateAndRender(state, views);
		}

		onChange() {
			track("Filter (Merkliste)", "Preis Filter", this.format(this.value));
		}

		onChangeMax() {
			this.dispatchAction(ACTION_RESET_PRICE_FILTER);
		}

		onChangeValue(value) {
			this.dispatchAction(ACTION_SET_PRICE_FILTER, value);
		}
	},
);
